import { Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText } from '@mui/material';
import { DefaultOutlinedButton } from './Buttons';

/**
 * - openDialog event handler function
 * - Dialog Title, Description
 * - closeOperation ('closeDialog') event handler function
 * - request operation function
 * - request and close button text
 * - request button UI
 * @returns returns Dialog UI
 */
export const DecisionDialog = ({
  openDialog,
  dialogTitle,
  dialogDescription,
  closeOperation,
  requestOperation,
  requestText,
  closeText,
  RequestButton,
}) => (
  <Dialog
    open={openDialog}
    onClose={() => {}}
    aria-labelledby="decision-dialog-title"
    aria-describedby="decision-dialog-description"
  >
    <DialogTitle id="decision-dialog-title">{dialogTitle}</DialogTitle>
    <DialogContent>
      <DialogContentText id="decision-dialog-description">{dialogDescription}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <DefaultOutlinedButton onClick={closeOperation}>{closeText}</DefaultOutlinedButton>
      <RequestButton onClick={requestOperation} autoFocus>
        {requestText}
      </RequestButton>
    </DialogActions>
  </Dialog>
);
